// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class RunBillTaskResource extends Resource {
    basePath: string = 'billing/bill-task/';

    objectPath: string = 'billing/bill-task/{ident}/';
}
